import { styled } from "styled-components";
import { HighlightElement } from "./highlightElement";
import { numberWithSpaces } from "@/utils/numberWithSpacing";
import { translateFuel } from "@/utils/translateFuel";
import { Fuel, Transmission } from "@/data/bruktbilsalgBackend/types/car.types";
import { translateTransmission } from "@/utils/translateTransmission";
import { tokens } from "@gnist/themes/tokens.css.js";

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${tokens.spacing.s};
`;

interface Props {
  modelYear: number;
  fuel: Fuel;
  mileage: number;
  transmission: Transmission;
}

export const HighlightsSection = ({
  modelYear,
  fuel,
  mileage,
  transmission,
}: Props) => {
  return (
    <Wrapper>
      <HighlightElement
        label={"Årsmodell"}
        value={`${modelYear}`}
        icon={"new_calendar"}
      />
      <HighlightElement
        label={"Kilometerstand"}
        value={numberWithSpaces(mileage) + " km"}
        icon={"speed"}
      />

      <HighlightElement
        label={"Drivstoff"}
        value={translateFuel(fuel)}
        icon={"new_gas_station"}
      />
      <HighlightElement
        label={"Girkasse"}
        value={translateTransmission(transmission)}
        icon={"gearshift"}
      />
    </Wrapper>
  );
};
